export default __webpack_public_path__ + "static/media/br29.7a83b456.png";